import * as RT from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";
import { useHiddenSubtree } from "./hiddenSubtree";

export interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  delayDuration?: number;
  disabled?: boolean;
}

export function Tooltip({
  content,
  children,
  side = "top",
  align = "center",
  delayDuration = 250,
  disabled = false,
}: TooltipProps) {
  const hidden = useHiddenSubtree();
  if (disabled || content === null || content === undefined || content === "") {
    return <>{children}</>;
  }
  return (
    <RT.Provider delayDuration={delayDuration}>
      <RT.Root>
        <RT.Trigger asChild>{children}</RT.Trigger>
        {!hidden && (
        <RT.Portal>
          <RT.Content
            side={side}
            align={align}
            sideOffset={6}
            className="z-[var(--z-tooltip)] max-w-xs rounded-md border border-border-default bg-surface-2 px-2 py-1 text-xs text-fg-default shadow-[var(--shadow-popover)] animate-fade-in"
          >
            {content}
            <RT.Arrow className="fill-[color:var(--color-surface-2)]" />
          </RT.Content>
        </RT.Portal>
        )}
      </RT.Root>
    </RT.Provider>
  );
}
